import { Injectable } from '@angular/core';
import {
  ADMIN_ROLE,
  REFERENCER_ROLE,
  CONTRIBUTOR_ROLE,
  SUPERADMIN_ROLE,
  TRACKER_ROLE,
  ADMINISTRATOR_ROLE,
  VALIDATOR_ROLE,
  TECHNICAL_ADMINISTRATOR_ROLE,
  CONTRIBUTORV2_ROLE,
} from '../../constant/app.constants';
import { SessionService } from '../authentication/session.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private readonly sessionService: SessionService) {}

  hasRole(role: string): boolean {
    return this.sessionService.getUserInfo()?.roles?.includes(role) ?? false;
  }

  hasAnyRole(roles: string[]): boolean {
    return roles.some((role) => this.hasRole(role));
  }

  isAdmin(): boolean {
    return this.hasRole(ADMIN_ROLE);
  }

  isAdministrator(): boolean {
    return this.hasRole(ADMINISTRATOR_ROLE);
  }

  isSuperAdmin(): boolean {
    return this.hasRole(SUPERADMIN_ROLE);
  }

  isReferencer(): boolean {
    return this.hasRole(REFERENCER_ROLE);
  }

  isContributor(): boolean {
    return this.hasRole(CONTRIBUTOR_ROLE);
  }

  isContributorV2(): boolean {
    return this.hasRole(CONTRIBUTORV2_ROLE);
  }

  isTracker(): boolean {
    return this.hasRole(TRACKER_ROLE);
  }

  isValidator(): boolean {
    return this.hasRole(VALIDATOR_ROLE);
  }

  isTechnicalAdministrator(): boolean {
    return this.hasRole(TECHNICAL_ADMINISTRATOR_ROLE);
  }
}
